'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from 'react';
import Modal from 'react-modal';
import Image from 'next/image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@awesome.me/kit-94e593bf23/icons/sharp/light';
import { faHiveQuickShip } from '@awesome.me/kit-94e593bf23/icons/kit/custom';
import { useAppContext } from '@/app/_lib/_context';
import { useCart } from '@/app/_lib/hooks';
import addToCartAction from '@/app/_lib/actions/AddToCartAction';
import QuantityInput from '@/app/_components/QuantityInput';
import { decodeEntities } from '@/app/_lib/services/ClientUtil';
import '@/app/_styles/react-modal-slide-panel.css';
const QuickShipModal = t0 => {
  const $ = _c(31);
  const {
    isOpen,
    setIsOpen,
    sub_product,
    quickShipItems,
    onItemAdded
  } = t0;
  const {
    openCartModal
  } = useAppContext();
  const {
    refresh
  } = useCart();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [quantities, setQuantities] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  useEffect(_temp, t2);
  let t3;
  if ($[2] !== setIsOpen) {
    t3 = () => {
      setIsOpen(false);
    };
    $[2] = setIsOpen;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const closeModal = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = (itemId, newQuantity) => {
      setQuantities(prev => ({
        ...prev,
        [itemId]: newQuantity
      }));
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleQuantityChange = t4;
  let t5;
  if ($[5] !== quantities) {
    t5 = itemId_0 => quantities[itemId_0] || 1;
    $[5] = quantities;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const getQuantity = t5;
  let t6;
  if ($[7] !== closeModal || $[8] !== getQuantity || $[9] !== onItemAdded || $[10] !== openCartModal || $[11] !== refresh || $[12] !== sub_product) {
    t6 = async item_0 => {
      const quantity = getQuantity(item_0.id);
      const optionsObject = {};
      if (item_0.options && Array.isArray(item_0.options)) {
        item_0.options.forEach(option => {
          optionsObject[option.selection_id] = {
            selection_id: option.selection_id,
            option_id: option.option_id,
            option_name: option.option_name,
            selection_label: option.selection_label,
            option_price: option.option_price,
            option_photo: option.option_photo
          };
        });
      }
      const swatchesObject = {};
      if (item_0.swatches && Array.isArray(item_0.swatches)) {
        item_0.swatches.forEach(swatch_0 => {
          swatchesObject[swatch_0.swatch_set_id] = {
            swatch_index: swatch_0.swatch_index,
            swatch_id: swatch_0.swatch_id,
            swatch_set_id: swatch_0.swatch_set_id,
            swatch_line_id: swatch_0.swatch_line_id,
            swatch_name: swatch_0.swatch_name,
            swatch_price: swatch_0.swatch_price,
            swatch_photo: swatch_0.swatch_photo,
            swatch_set_label: swatch_0.swatch_set_label,
            xref_id: swatch_0.xref_id
          };
        });
      }
      const variant = item_0.image_url ? {
        file_name: item_0.image_url,
        description: item_0.variant_description,
        sku: item_0.sku
      } : null;
      const cartObject = {
        quantity,
        product: {
          sub_product_id: item_0.sub_product_id,
          options: optionsObject,
          swatches: swatchesObject,
          ...(variant && {
            variant
          })
        }
      };
      const response = await addToCartAction(cartObject);
      if (response.success) {
        refresh(response.cart);
        if (onItemAdded) {
          onItemAdded(item_0);
        }
        openCartModal({
          message: "The item was added to your cart.",
          sub_product
        });
        closeModal();
      } else {
        console.error("Failed to add item to cart");
        alert("Failed to add item to cart. Please try again.");
      }
    };
    $[7] = closeModal;
    $[8] = getQuantity;
    $[9] = onItemAdded;
    $[10] = openCartModal;
    $[11] = refresh;
    $[12] = sub_product;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const handleAddToCart = t6;
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex items-center"><FontAwesomeIcon icon={faHiveQuickShip} className="text-xl text-primary mr-2 block" /><span className="text-xl">Quick Ship</span></div>;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <FontAwesomeIcon icon={faXmark} className="text-[28px] block" />;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== closeModal) {
    t9 = <div className="shrink-0 flex items-center justify-between site-padding py-3 border-b border-gray-8 bg-gray-3 leading-none">{t7}<button type="button" onClick={closeModal} className="text-light hover:text-primary flex items-center" aria-label="Close">{t8}</button></div>;
    $[16] = closeModal;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span className="text-primary">*</span>;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="shrink-0 flex items-center site-padding py-5 border-b border-gray-8 bg-white"><div className="text-xs text-light">{t10} Please refer to available inventory below for items that are available for quick ship.<br /><span className="text-primary">*</span> Quantities ordered in excess of the available inventory will ship per the lead times specified on the product page.</div></div>;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== getQuantity || $[21] !== handleAddToCart || $[22] !== quickShipItems) {
    t12 = <div className="flex-1 overflow-y-auto site-padding py-6">{quickShipItems && quickShipItems.length > 0 ? <div>{quickShipItems.map((item_1, index) => <div key={item_1.id}><div className="flex gap-4 py-6"><div className="flex-1 min-w-0"><h3 className="text-base font-medium mb-2">{decodeEntities(item_1.sub_product_name)}</h3>{item_1.options && item_1.options.length > 0 && <div className="mb-2">{item_1.options.map(_temp2)}</div>}{item_1.swatches && item_1.swatches.length > 0 && <div className="mb-2">{item_1.swatches.map(_temp3)}</div>}</div><div className="flex flex-col items-end gap-3"><QuantityInput quantity={getQuantity(item_1.id)} setQuantity={newQty => handleQuantityChange(item_1.id, newQty)} maxQuantity={item_1.quantity} /><div className="text-sm"><span className="text-ink-light">Available:</span> <span className="font-medium">{item_1.quantity}</span></div><button onClick={() => handleAddToCart(item_1)} className="btn btn-primary px-6 py-2 whitespace-nowrap">Add to Cart</button></div></div>{index < quickShipItems.length - 1 && <div className="h-px bg-gray-8" />}</div>)}</div> : <div className="text-center py-12 text-light">No quick ship items available at this time.</div>}</div>;
    $[20] = getQuantity;
    $[21] = handleAddToCart;
    $[22] = quickShipItems;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12 || $[25] !== t9) {
    t13 = <div className="h-full flex flex-col">{t9}{t11}{t12}</div>;
    $[24] = t12;
    $[25] = t9;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== closeModal || $[28] !== isOpen || $[29] !== t13) {
    t14 = <Modal overlayClassName="slide-panel fixed inset-0 outline-none lg:bg-modal-overlay z-[1000]" className={"fixed outline-none shadow overscroll-contain bg-white\n                inset-0 top-[var(--header-height)] [body.header-collapsed_&]:top-[var(--header-height-collapsed)]\n                lg:top-0 lg:right-0 lg:bottom-0 lg:left-auto lg:w-1/2"} isOpen={isOpen} onRequestClose={closeModal} contentLabel="Quick Ship Items" closeTimeoutMS={500} bodyOpenClassName="ReactModal__Body--open" htmlOpenClassName="ReactModal__Html--open">{t13}</Modal>;
    $[27] = closeModal;
    $[28] = isOpen;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  return t14;
};
export default QuickShipModal;
function _temp() {
  Modal.setAppElement("#hivenext");
}
function _temp2(option_0, idx) {
  return <div key={idx} className="text-sm capitalize"><span className="text-ink-light">{option_0.selection_label}:</span> <span className="font-medium">{option_0.option_name}</span></div>;
}
function _temp3(swatch_1, idx_0) {
  return <div key={idx_0} className="flex items-center gap-3 mb-2">{(swatch_1.swatch_thumb || swatch_1.swatch_photo) && <Image src={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/swatch_photos/${swatch_1.swatch_thumb || swatch_1.swatch_photo}`} alt={swatch_1.swatch_name} width={60} height={60} className="w-15 h-15 object-cover" />}<span className="text-sm"><span className="text-light">{swatch_1.swatch_set_label}:</span> {swatch_1.swatch_name}{parseFloat(swatch_1.swatch_price) > 0 && <span className="text-primary ml-1">+ ${parseFloat(swatch_1.swatch_price).toFixed(2)}</span>}</span></div>;
}